module.exports = {
  "dof-icon-button": {
    "alignItems": "center",
    "position": "relative"
  },
  "content": {
    "position": "relative"
  },
  "imgBox": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "overflow": "hidden"
  },
  "dof-icon-button-text": {
    "marginTop": "24",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "24",
    "textAlign": "center",
    "fontWeight": "400"
  },
  "triangle": {
    "position": "absolute",
    "width": "18",
    "height": "18",
    "overflow": "hidden",
    "transform": "rotateZ(270deg)",
    "transformOrigin": "center",
    "bottom": 0,
    "right": 0
  },
  "triangle-mask": {
    "width": "26",
    "height": "26",
    "transform": "rotateZ(45deg)",
    "transformOrigin": "left top"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-219e6f63!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-icon-button/index.vue
// module id = 447
// module chunks = 0 1